export default {
    filters: {
        title: "Filters",
        removeFilter: "Verwijder filter",
        filterIntensity: "Filter intensiteit",
        duotone: {
            title: "Duotone",
            desert: "Woestijn",
            peach: "Perzik",
            clash: "Botsing",
            plum: "Pruim",
            breezy: "Luchtig",
            deepBlue: "Diepblauw",
            frog: "Kikker",
            sunset: "Zonsondergang",
        },
        blackAndWhite: {
            title: "B en W",
            ad: "1920 Na Chr",
            greyed: "Vergrijsd",
            dusty: "Stoffig",
            litho: "Lithografie",
            sepia: "Sepia",
            weathered: "Versleten",
            hardStuff: "Sterke spullen",
        },
        vintage: {
            title: "Vintage",
            polaroid: "Polaroid",
            sunny: "Zonnige 70's",
            oldTimer: "Oldtimer",
            inferno: "Inferno",
            snappy: "Snappy",
        },
        smooth: {
            title: "Glad",
            chestnut: "Kastanje",
            softy: "Zoetsappig",
            pebble: "Kiezel",
            moss: "Moss",
            lemon: "Citroen",
            greenGap: "Groene kloof",
        },
        cold: {
            title: "Koud",
            colla: "Colla",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Levante",
            zephyr: "Zephyr",
        },
        warm: {
            title: "Warm",
            golden: "Gouden",
            lowFire: "Lage brand",
            sunrise: "Zonsopgang",
            flatBack: "Platte rug",
            pumpkin: "Pompoen",
        },
    },
};
